<template>
  <div class="evento-wrapper">

    <!-- Fondo -->
    <img
      :src="require('@/assets/F1.jpg')"
      alt="Fondo"
      class="fondo-textura"
    />

    <!-- Ramita -->
    <img
      src="@/assets/ramita.avif"
      alt="Decoración"
      class="ramita-fondo-visual"
    />

    <!-- PADRINOS -->
    <div class="tarjeta-evento reveal">
   <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>
      <p class="titulo-evento">
        Padrinos de Boda
      </p>

      <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>

      <p class="lugar">
        Sin ellos no sería igual
      </p>

      <div class="nombre-elegante">
        Miguel Vargas
      </div>

      <div class="ampersand">
        &
      </div>

      <div class="nombre-elegante1">
        Denisse Betances
      </div>

    </div>

    <!-- DAMAS -->
    <div class="dresscode-box reveal">
   <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>
      <p class="dresscode-title">
        Damas
      </p>

      <div class="separator-holder mini reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>

      <div class="damas-lista">

        <div class="dama-item">
          Anabel Paniagua
        </div>

        <div class="dama-item">
        Yomaira Ramirez 

        </div>

        <div class="dama-item">
        Leydiana Mejía 
        </div>

          <div class="dama-item">
        Georgina Melenciano
        </div>

      </div>

    </div>

    <!-- TESTIGOS -->
    <div class="dresscode-box reveal">
   <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>
      <p class="dresscode-title">
        Testigos
      </p>

      <div class="separator-holder mini reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>

      <div class="damas-lista">

        <div class="dama-item">
          Nestor Matos 
        </div>

        <div class="dama-item">
         Yaniris Montesino
        </div>

    

      </div>


    </div>

  
  </div>
</template>

<script>
import { onMounted } from 'vue'

export default {
  name: 'PadrinosDamasBonito',

  setup() {

    onMounted(() => {

      const observer = new IntersectionObserver((entries)=>{

        entries.forEach((entry)=>{

          if(entry.isIntersecting){

            entry.target.classList.add('visible')

          }

        })

      }, { threshold: 0.15 })

      document.querySelectorAll('.reveal').forEach(el=>{
        observer.observe(el)
      })

    })

    return {}
  }
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Poppins:wght@300;400;500&display=swap');

/* ========= CONTENEDOR ========= */

.evento-wrapper{
  position:relative;
  width:100%;
  padding:120px 20px;
  overflow:hidden;

  display:flex;
  flex-direction:column;
  align-items:center;
  gap:34px;
}

/* ========= FONDO ========= */

.fondo-textura{
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
  object-fit:cover;
  z-index:0;
}

/* ========= RAMITAS ========= */

.ramita-fondo-visual{
  position:absolute;
  top:-120px;
  left:0;
  width:100%;
  opacity:.05;
  z-index:1;
  pointer-events:none;
}

.ramita-decorativa{
  width:90px;
  margin-top:20px;
  opacity:.7;
  z-index:2;
}

/* ========= TARJETAS ========= */

.tarjeta-evento,
.dresscode-box{

  position:relative;
  z-index:2;

  width:100%;
  max-width:390px;

  padding:10px 28px;

  text-align:center;




}

/* ========= TITULOS ========= */

.titulo-evento,
.dresscode-title{

  font-family:'Playfair Display', serif;
  font-size:38px;
  line-height:1.3;
  color:#b08a5a;
}

/* ========= TEXTO ========= */

.lugar{
  font-family:'Playfair Display', serif;
  font-size:22px;
  line-height:1.8;
  color:#6f6660;
  margin-top:18px;
}

/* ========= NOMBRES ========= */

.nombre-elegante{

  margin-top:20px !important;

  font-family:'Playfair Display', serif;
  font-size:30px !important;

  color:#7a6757;

  line-height:1.7;
}

.nombre-elegante1{

  margin-top:0px;

  font-family:'Playfair Display', serif;
  font-size:28px !important;

  color:#7a6757;

  line-height:1.7;
}


 .ampersand{

  font-family:'Cormorant Garamond', serif;

  font-size:58px;

  color:#cdb08a;

  line-height:1;
margin-bottom: -20px;
  margin:10px 0;

}


/* ========= LISTA ========= */

.damas-lista{
  margin-top:18px;

  display:flex;
  flex-direction:column;
  gap:16px;
}

.dama-item{

  font-family:'Playfair Display', serif;

  font-size:24px;

  color:#6f6660;

  line-height:1.8;

  border-top:
  1px solid rgba(176,138,90,.25);

  border-bottom:
  1px solid rgba(176,138,90,.25);

  padding:12px 0;
}

/* ========= SEPARADORES ========= */

.separator-holder{
  display:flex;
  justify-content:center;
  margin:20px 0;
}

.separator-holder.mini{
  margin:12px 0;
}

.separador-img{
  width:80%;
  opacity:.9;
}

/* ========= ANIMACIONES ========= */

.reveal{
  opacity:0;
  transform:translateY(45px);
  transition:all 1.2s ease;
}

.reveal.visible{
  opacity:1;
  transform:translateY(0);
}

/* ========= RESPONSIVE ========= */

@media(max-width:768px){

  .evento-wrapper{
    padding:90px 18px;
  }

  .titulo-evento,
  .dresscode-title{
    font-size:32px;
  }

  .lugar{
    font-size:19px;
  }

  .nombre-elegante{
    font-size:25px;
  }

  .dama-item{
    font-size:21px;
  }

}

</style>